<template>
  <div class="smartpost-banner-wrapper">
    <div class="banners-view">
      <div class="left-banners">
        <img class="smartpost-logo" :src="require('@/assets/images/smartpost_logo_v2.0.svg')" />
        <div class="description banner-desc" v-html="getWordings.smartpostBannerDescription"></div>
        <div class="button-wrapper">
          <LinkButton
            class="link-button"
            :wordingKey="'devBannerContactButton'"
            :hrefLink="contactUsDomain"
            :isShowIcon="false"
          />
          <LinkButton
            :isWhiteButton="true"
            class="link-button download-btn"
            :wordingKey="'devBannerDownloadButton'"
            :hrefLink="downloadDocsURL"
            :isShowIcon="false"
            :openNewTab="true"
          />
        </div>
      </div>
      <div class="right-banners">
        <img :src="smartpostAnimation + '?r=' + timestamp" />
        <div class="image-background"></div>
      </div>
      <div class="smartpost-triangle-mobile">
        <img :src="require('@/assets/images/triangle-smartpost.svg')" />
      </div>
    </div>
    <div class="capital-partnership">
      <p class="partnership-text" v-html="getWordings.capitalPartnershipDescription"></p>
      <img class="jp-capital-logo" :src="require('@/assets/images/jp_capital-partnership.svg')" />
    </div>
  </div>
</template>

<script lang="ts">
// @ is an alias to /src
import LinkButton from "@/components/controls/LinkButton.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import smartpostAnimation from "@/assets/animation/smartpost_v2.0.svg";
import { Getter } from "vuex-class";

@Component({
  name: "SmartPOSTBannersView",
  components: {
    LinkButton
  }
})
export default class SmartPOSTBannersView extends Vue {
  @Getter("text/getWordings") getWordings!: any;
  @Prop({ type: String }) private timestamp!: string;
  smartpostAnimation: string = smartpostAnimation;
  contactUsDomain = process.env.VUE_APP_XID_CONTACT_URL as string;
  downloadDocsURL = process.env.VUE_APP_XID_DOCS_DOWNLOAD_URL as string;
}
</script>

<style lang="scss" scoped>
.smartpost-banner-wrapper {
  background-color: $gs8;
}

.banners-view {
  @include layoutPadding();
  @include flex(left, center);
  flex-wrap: nowrap;
  position: relative;
  padding-right: 0;
  @include mq(l) {
    @include flex(center, center);
    padding-right: calc((100vw - 715px) / 2);
  }
  @include mq(m) {
    padding-right: 30px;
  }
  .smartpost-triangle-mobile {
    display: none;
    img {
      width: 100vw;
    }
    @include mq(l) {
      display: block;
      position: absolute;
      bottom: 0;
    }
  }

  .left-banners {
    text-align: left;
    max-width: 600px;
    width: 100%;
    @include mq(l) {
      text-align: center;
      width: 100%;
      max-width: unset;
    }
  }

  .right-banners {
    position: relative;
    width: 100%;
    > img {
      position: absolute;
      z-index: 1;
      top: 50px;
      left: 150px;
      @include mq(l) {
        display: inline-block;
        width: 75%;
        position: relative;
        top: 4px;
        left: unset;
        margin-top: 20px;
      }
    }
  }

  .image {
    @include size(500px, 500px);
    background-color: $gs6;
    @include mq(l) {
      width: 100%;
      height: 250px;
    }
  }

  .image-background {
    @include size(100%, 500px);
    background-image: linear-gradient($sp-color2, $sp-color1);
    position: relative;
    margin-left: 340.5px;
    @include mq(l) {
      display: none;
    }
  }
  .image-background:before {
    content: "";
    @include size(353.54px);
    border-bottom-left-radius: 15px;
    background-image: linear-gradient(135deg, $sp-color2, $sp-color1);
    transform: rotate(45deg);
    position: absolute;
    left: -178px;
    top: 73px;
  }

  .smartpost-logo {
    margin-bottom: 20px;
    @include mq(l) {
      margin-top: 40px;
      width: 70%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .title {
    @include titleFz(xl);
    @include mq(l) {
      margin-top: 40px;
      text-align: center;
      @include titleFz(xs);
    }
    @include fw(heavy);
    line-height: 60px;
    margin-bottom: 20px;
  }

  .description {
    @include titleFz(xs);
    @include mq(l) {
      @include fz(m);
    }
    line-height: 40px;
    // @include fw(heavy);
  }

  .button-wrapper {
    margin-top: 60px;
    @include flex(left, center);
    @include mq(l) {
      width: 100%;
      margin-top: 20px;
      flex-direction: column;
      align-items: center;
    }
  }
  .download-btn {
    margin-left: 30px;
    @include mq(l) {
      margin-left: 0px;
      margin-top: 10px;
    }
  }
}

.capital-partnership {
  @include layoutPadding();
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 40px;
  padding-bottom: 100px;
  @include mq(m) {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .partnership-text {
    color: #555;
    font-size: 16px;
    line-height: 2;
    letter-spacing: 0.03em;
    margin-bottom: 20px;
    @include mq(m) {
      font-size: 12px;
      line-height: 1.8;
    }
  }
  .jp-capital-logo {
    width: 300px;
    height: auto;
    @include mq(m) {
      width: 160px;
    }
  }
}
</style>
